import React, {useState, useEffect} from "react";

import "./FacilityCapture.css";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {LeftLabelSelect} from "../../../common/input/left-label-select/LeftLabelSelect";
import {LeftLabelTextInput} from "../../../common/input/left-label-text-input/LeftLabelTextInput";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";
import {
    createFacility,
    retrieveProvincesForDropdown,
    retrieveCountriesForDropdown,
    updateFacility,
} from "../../../../services/FacilityService";

export const FacilityCapture = ({context, navigateTo, navigateBack, setSpinnerText, showToaster}) => {

    const [externalReference] = useState(context.selectedFacility ? context.selectedFacility.externalReference : null);
    const [country, setCountry] = useState(context.selectedFacility ? context.selectedFacility.country : null);
    const [province, setProvince] = useState(context.selectedFacility ? context.selectedFacility.province : null);
    const [district, setDistrict] = useState(context.selectedFacility ? context.selectedFacility.district : null);
    const [subDistrict, setSubDistrict] = useState(context.selectedFacility ? context.selectedFacility.subDistrict : null);
    const [facility, setFacility] = useState(context.selectedFacility ? context.selectedFacility.facility : null);
    const [active, setActive] = useState(context.selectedFacility ? context.selectedFacility.active : false);
    const [countryList, setCountryList] = useState();
    const [provinceList, setProvinceList] = useState();

    useEffect(() => {
        setSpinnerText("Retrieving Countries");
        const fetchData = async () => {
            const [data] = await retrieveCountriesForDropdown(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const countryList = []
                    const resultMap = data.resultMap;
                    for (const property in resultMap) {
                        countryList.push({value: property, label: resultMap[property]});
                    }
                    setCountryList(countryList);
                }
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (country) {
            setSpinnerText("Retrieving Provinces");
            const fetchData = async () => {
                const [data] = await retrieveProvincesForDropdown(context.username, country.label);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const provinceList = []
                        const resultMap = data.resultMap;
                        for (const property in resultMap) {
                            provinceList.push({value: property, label: resultMap[property]});
                        }
                        setProvinceList(provinceList);
                    }
                }
                setSpinnerText(null);
            }
            fetchData();
        }
    }, [country]);

    const handleClick = async () => {
        const facilityToBeSaved = {
            externalReference,
            country: country.label,
            province: province.label,
            district,
            subDistrict,
            facility,
            active
        };
        if (null === externalReference) {
            setSpinnerText("Creating Facility");
            const response = await createFacility(context.username, facilityToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating Facility");
            const response = await updateFacility(context.username, facilityToBeSaved);
            handleResponse(response);
        }
        navigateTo("facilityTable");
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                navigateTo("facilityTable");
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    return (
        <div className="facility-capture-container">
            <div className="facility-capture-form-container">
                <LeftLabelSelect labelText="Country:" options={countryList} value={country} onChange={(country) => {
                    setCountry(country)
                }}/>
                <LeftLabelSelect labelText="Province:" options={provinceList} value={province} onChange={(province) => {
                    setProvince(province)
                }}/>
                <LeftLabelTextInput labelText="District:" defaultValue={district} handleChange={({target}) => {
                    setDistrict(target.value)
                }}/>
                <LeftLabelTextInput labelText="Sub-District:" defaultValue={subDistrict} handleChange={({target}) => {
                    setSubDistrict(target.value)
                }}/>
                <LeftLabelTextInput labelText="Facility:" defaultValue={facility} handleChange={({target}) => {
                    setFacility(target.value)
                }}/>
                <LeftLabelToggle labelText="Active:" active={active} setActive={setActive}/>
            </div>
            <div className="facility-capture-button-container">
                <StandardButton text={context.selectedFacility ? "Update Location" : "Add Location"}
                                onClick={handleClick}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>
        </div>
    );
}
